<div class="mat-headline-5 title">{{ "ONSIP_I18N.MIGRATE_SIP_DOMAIN" | translate }}</div>
<div class="subtitle">
  {{ "ONSIP_I18N.USE_YOUR_OWN_DOMAIN_NAME_WITH_YOUR_ONSIP_HOSTED_PBX" | translate }}
</div>
<onsip-loading-container [deferCond]="isDataObtained$">
  @if ((migratePanel$ | async) === 'view') {
  <onsip-migrate-sip-domain-view (editPanel)="togglePanel('edit')"></onsip-migrate-sip-domain-view>
  } @if ((migratePanel$ | async) === 'edit') {
  <onsip-migrate-sip-domain-edit (editPanel)="togglePanel('view')"></onsip-migrate-sip-domain-edit>
  }
</onsip-loading-container>
<div class="mat-body-2 contact-support">
  {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
  <a class="support-link" [routerLink]="[views.CONTACT_SUPPORT]">
    {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
  </a>
</div>
